import { DataBean } from "../DataBean";

export class KpiConstantLevelTypes extends DataBean {



    public async getKpiConstantLevelTypes(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getKpiConstantLevelTypes_Number", [id]);
    }

}
